export const state = {
  addBeacon: {
  },
  updateBeacon: {
  },
  beacon: {
    locationId: '',
    locationName: '',
    uuid: '',
    major: '',
    minor: ''
  },
  beacons: []
}
export const mutations = {
  setBeacons (state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      response.data['data'][i]['checked'] = false
    }
    state.beacons = response.data['data']
  },
  setDetail  (state, response) {
    for (var i in response.data['data']) {
      if (response.data['data'][i] === null) {
        response.data['data'][i] = ''
      }
    }
    state.beacon = response.data['data'][0]
    state.updateBeacon = {}
    state.updateBeacon.locationId = state.beacon.locationId
  },
  inputUpdate (state, payload) {
    if ((payload.name === 'major' && payload.value === '') || (payload.name === 'minor' && payload.value === '')) {
      payload.value = 0
    }
    state.updateBeacon[payload.name] = payload.value
  },
  inputAddUpdate (state, payload) {
    if ((payload.name === 'major' && payload.value === '') || (payload.name === 'minor' && payload.value === '')) {
      payload.value = 0
    }
    state.addBeacon[payload.name] = payload.value
  },
  clearBeacon (state) {
    state.addBeacon = {}
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/beaconModules/beaconMutation.js